<template>
  <div class="vx-row">
    <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 mb-6 sm:mb-base sm:pr-3" 
        v-if="userRole !== 'user'">
      <v-select
        class="w-full"
        :options="userOptions"
        v-model="userValue"
        @input="userHandleChange"
        :clearable="true"
        :placeholder="$t('apiaries.filters.UserPlaceholder')"
        :searchable="true"
        :disabled="userDisabled"
        :loading="userDisabled"
      >
        <template v-slot:no-options="{ searching }">
          <template v-if="searching">
            {{ $t("select.NoMatching") }}
          </template>
          <template v-else>
            {{ $t("select.NoData") }}
          </template>
        </template>
        <template #spinner="{ loading }">
          <feather-icon
            class="ml-2 bx-spin"
            v-if="loading"
            icon="LoaderIcon"
            svgClasses="w-4 h-4"
          ></feather-icon>
        </template>
      </v-select>
    </div>
    <div class="vx-col w-full mb-base" 
        :class="userRole !== 'user' ? 'sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 sm:pl-0' : ''">
      <v-select
        class="w-full"
        :options="apiaryOptions"
        v-model="apiaryValue"
        @input="apiaryHandleChange"
        :clearable="true"
        :placeholder="$t('apiaries.SelectApiary')"
        :disabled="apiaryDisabled"
        :loading="apiaryDisabled"
      >
        <template v-slot:no-options="{ searching }">
          <template v-if="searching">
            {{ $t("select.NoMatching") }}
          </template>
          <template v-else>
            {{ $t("select.NoData") }}
          </template>
        </template>
        <template #spinner="{ loading }">
          <feather-icon
            class="ml-2 bx-spin"
            v-if="loading"
            icon="LoaderIcon"
            svgClasses="w-4 h-4"
          ></feather-icon>
        </template>
        <template #list-footer>
          <li
            ref="load-rule-apiary"
            class="loader"
            v-if="isApiaryLazyLoadLoading == true"
          >
            <div class="flex items-center justify-center w-full">
              <div>
                <feather-icon
                  icon="LoaderIcon"
                  class="mr-3 bx-spin text-warning"
                  svgClasses="w-5 h-5"
                ></feather-icon>
              </div>
            </div>
            <infinite-loading @infinite="apiaryInfiniteHandler">
              <div slot="spinner"></div>
              <div slot="no-more"></div>
              <div slot="no-results"></div>
            </infinite-loading>
          </li>
        </template>
      </v-select>
    </div>
  </div>
</template>
<script>
import i18n from '../../../i18n/i18n.js'
import vSelect from 'vue-select'
import InfiniteLoading from 'vue-infinite-loading'

export default {
  components: {
    vSelect,
    InfiniteLoading
  },
  props:{
    apiaryData:{
      type:Object,
      require:true
    }
  },
  data () {
    return {
      // Apiary
      apiaryDisabled: true,
      apiaryOptions: [],
      apiaryValue: null,
      apiaryCursor: null,
      isApiaryLazyLoadLoading: false,

      //User
      userDisabled: true,
      userOptions: [],
      userValue: null,
      userCursor: null,
      isUserLazyLoadLoading: false,

      filters: {
        user: null,
        apiary: null
      }
    }
  },
  watch: {
    apiaryData: {
      handler (n, o) {
        if (o) {
          this.apiaryOptions = []
          if (n.results.length) {
            n.results.map((value) => {
              this.apiaryOptions.push({
                label: value.name,
                value: value.id
              })
            })
          }

          this.apiaryDisabled = false

          this.apiaryCursor = n.next
          if (n.next === null) {
            this.isApiaryLazyLoadLoading = false
          } else {
            this.isApiaryLazyLoadLoading = true
          }
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    userInfo () {
      return this.$store.getters.returnUserInfo
    },
    userRole () {
      return this.$store.getters.userRole
    },
    hiveFilters () {
      return this.$store.getters.hiveFilters
    }
  },
  mounted () {
    this.$store.dispatch('getHiveFilters', {data:null, type:'apiary'})
    this.$store.dispatch('getHiveFilters', {data:null, type:'user'})

    if (this.apiaryData) {
      this.apiaryOptions = []
      if (this.apiaryData.results.length) {
        this.apiaryData.results.map((value) => {
          this.apiaryOptions.push({
            label: value.name,
            value: value.id
          })
        })
      }

      this.apiaryDisabled = false

      this.apiaryCursor = this.apiaryData.next
      if (this.apiaryData.next === null) {
        this.isApiaryLazyLoadLoading = false
      } else {
        this.isApiaryLazyLoadLoading = true
      }
    } else {
      this.apiaryOptions = []
      this.apiaryDisabled = false
    }
      
    if (this.userRole !== 'user') {
      this.getUserAndCompanyList()
    }
  },
  methods: {
    // Apiary Operations
    apiaryHandleChange (val) {
      let filter = null
      if (val && Object.prototype.hasOwnProperty.call(val, 'value')) {
        filter = val.value
      }
      this.$store.dispatch('getHiveFilters', {data:filter, type:'apiary'})
    },
    handleApiarySearch (search) {
      let searchData = `?search=${search}`
      if (
        this.userValue &&
        Object.prototype.hasOwnProperty.call(this.userValue, 'value')
      ) {
        searchData = `?user=${this.userValue.value}&search=${search}`
      }
      this.getApiaries(searchData)
    },
    getApiaries (params) {
      this.$store
        .dispatch('getApiariesData', params)
        .then((response) => {
          this.apiaryOptions = []

          if (response.data.results.length) {
            response.data.results.map((value) => {
              this.apiaryOptions.push({
                label: value.name,
                value: value.id
              })
            })
          }

          this.apiaryDisabled = false

          this.apiaryCursor = response.data.next
          if (response.data.next === null) {
            this.isApiaryLazyLoadLoading = false
          } else {
            this.isApiaryLazyLoadLoading = true
          }
        })
        .catch((error) => {
          this.apiaryDisabled = false
          this.errorMsg(error)
        })
    },
    apiaryInfiniteHandler ($state) {
      if (this.apiaryCursor !== null) {
        this.$store
          .dispatch('getApiariesLazyLoadData', this.apiaryCursor)
          .then((response) => {
            const lazyLoadData = []
            if (response.data.results.length) {
              response.data.results.map((value, index) => {
                lazyLoadData.push({
                  label: value.name,
                  value: value.id
                })
                if (index + 1 === response.data.results.length) {
                  this.apiaryOptions.push(...lazyLoadData)
                }
              })
            }
            this.apiaryCursor = response.data.next
            if (response.data.next === null) {
              this.isApiaryLazyLoadLoading = false
              $state.complete()
            } else {
              this.isApiaryLazyLoadLoading = true
              $state.loaded()
            }
          })
          .catch((error) => {
            this.errorMsg(error)
          })
      }
    },

    // User Operations
    userHandleChange (val) {
      this.apiaryDisabled = true
      this.apiaryValue = null
      let filter = null
      if (
        val &&
        Object.prototype.hasOwnProperty.call(val, 'value')
      ) {
        this.getApiaries(`?user=${val.value}`)
        filter = val.value
      } else {
        this.getApiaries('')
        filter = null
      }
      this.$store.dispatch('getHiveFilters', {data:filter, type:'user'})
      this.$store.dispatch('getHiveFilters', {data:null, type:'apiary'})
    },
    getUserAndCompanyList () {
      this.$store
        .dispatch('getUserAndCompanyList')
        .then((response) => {
          this.userOptions = [
            {
              value: this.userInfo.user_id,
              label: i18n.t('hives.Myhive')
            }
          ]
          if (response.data.length) {
            response.data.map((value) => {
              let data = null
              if (value.company && !value.first_name) {
                data = {
                  value: value.id,
                  label: value.company
                }
              }
              if (value.first_name && !value.company) {
                data = {
                  value: value.id,
                  label: `${value.first_name} ${value.last_name}`
                }
              }

              if (value.first_name && value.company) {
                data = {
                  value: value.id,
                  label: `${value.company}-${value.first_name} ${value.last_name}`
                }
              }

              this.userOptions.push(
                data === null
                  ? {
                    value: value.id,
                    label: value.email
                  }
                  : data
              )
            })
          }

          this.userDisabled = false
        })
        .catch((error) => {
          this.userDisabled = false
          this.errorMsg(error)
        })
    },
    errorMsg (error) {
      this.$store.dispatch('errorMsg', error).then((res) => {
        this.$vs.notify({
          title: i18n.t('notifyAlert.error.title'),
          text: res,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          position: 'top-right'
        })
      })
    }
  }
}
</script>
<style lang="scss">
.hive-list__header_filters{
    .vs--disabled{
       .vs__dropdown-toggle {
        background: none !important;
    } 
    }
    .vs__dropdown-toggle {
        background: white !important;
    }   
}

</style>